import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { CALL_AUDIO_EVENT } from '../services/call-audio-bridge';

/** Receiver/speaker selection is native hardware routing, not HTML volume. */
export function useCallSpeaker() {
  const [available, setAvailable] = useState(false);
  const [speaker, setSpeaker] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;
    const bridge = (window as any).ReactNativeWebView;
    if (!bridge) return;
    const handle = (event: Event) => {
      const data = (event as CustomEvent).detail;
      setAvailable(data?.available === true);
      setSpeaker(data?.speaker === true);
      setError(typeof data?.error === 'string' ? data.error : null);
      setPending(false);
    };
    window.addEventListener(CALL_AUDIO_EVENT, handle);
    // The app's first reply can arrive before this page listens (or while its audio is still
    // starting): ask again until it says audio is available, for up to 20 seconds.
    let tries = 0, answered = false;
    const onReply = (event: Event) => { if ((event as CustomEvent).detail?.available === true) answered = true; };
    window.addEventListener(CALL_AUDIO_EVENT, onReply);
    const ask = () => bridge.postMessage(JSON.stringify({ type: 'getCallAudioState' }));
    ask();
    const timer = setInterval(() => { if (answered || ++tries > 20) clearInterval(timer); else ask(); }, 1000);
    return () => { clearInterval(timer); window.removeEventListener(CALL_AUDIO_EVENT, handle); window.removeEventListener(CALL_AUDIO_EVENT, onReply); };
  }, []);
  const toggle = () => {
    if (!available || pending) return;
    setPending(true); setError(null);
    (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'setCallSpeaker', enabled: !speaker }));
  };
  return { available, speaker, pending, error, toggle };
}
